var map = {
	"./AmiyaBagchi.jpg": 621,
	"./AmiyaBagchi.png": 622,
	"./ChinmayTumbe.png": 623,
	"./DavidArnold.jpg": 624,
	"./DavidArnold.png": 625,
	"./DouglasHaynes.jpg": 626,
	"./DouglasHaynes.png": 627,
	"./DwijendraTripathi.jpg": 628,
	"./DwijendraTripathi.png": 629,
	"./GeoffreyJones.png": 630,
	"./IndiraChowdhury.jpg": 631,
	"./IndiraChowdhury.png": 632,
	"./JosephSassoon.jpg": 633,
	"./JosephSassoon.png": 634,
	"./MedhaKudaisya.jpg": 635,
	"./MedhaKudaisya.png": 636,
	"./MilanBalaban.png": 637,
	"./PrafullAnubhai.jpg": 638,
	"./PrafullAnubhai.png": 639,
	"./RamachandraGuha.png": 640,
	"./RituBirla.jpg": 641,
	"./RituBirla.png": 642,
	"./RobertPerks.png": 643,
	"./RossBassett.jpg": 644,
	"./RossBassett.png": 645,
	"./SusiePak.png": 646,
	"./SvenBeckert.png": 647,
	"./SvenBeckertOld.png": 648,
	"./TirthankarRoy.jpg": 649,
	"./TirthankarRoy.png": 650
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 620;